import { queryState, createState, updateState, fetchAllState } from "./creator";

export const queriedRegions = queryState.selector;

export const createRegionObj = createState.selector;

export const updateRegionObj = updateState.selector;

export const fetchedRegions = fetchAllState.selector;
